<div class="layout-weather-container scrollable-component-container">
  <div
    class="attribute-editor-component scrollable-component-settings te-scrollable-container"
  >
    <div
      class="attribute-editor-row"
      [ngClass]="{
        'has-error': !hasValidAddress,
        'has-success': hasValidAddress,
      }"
    >
      <p class="help-block" [shown]="!hasValidAddress && !canEditCompany">
        Set an address to see the weather. Please contact your System
        Administrator to set an address to your company.
      </p>
      <p class="help-block" [shown]="!hasValidAddress && canEditCompany">
        Set an address to see the weather. Navigate to
        <a rv-link appearance="inline" uiSref="apps.settings.company-details"
          >Company Settings</a
        >, enter your address and click Save.
      </p>
      <p [shown]="hasValidAddress">
        This Presentation will show the weather for the Address of the Display
        it is playing on.
      </p>

      <!-- Unit Selection -->
      <div class="form-group">
        <label class="control-label u_margin-sm-top">Unit:</label>
        <mat-button-toggle-group
          [(ngModel)]="scale"
          (ngModelChange)="setScale($event)"
          hideSingleSelectionIndicator="true"
        >
          <mat-button-toggle value="F">°F</mat-button-toggle>
          <mat-button-toggle value="C">°C</mat-button-toggle>
        </mat-button-toggle-group>
      </div>

      <!-- Layout Selection -->
      <div class="form-group layout-selector">
        <label class="control-label" id="layout-selection-label"
          >Choose Layout:</label
        >
        <div
          class="layout-container"
          role="radiogroup"
          aria-labelledby="layout-selection-label"
        >
          <button
            type="button"
            class="layout-option"
            [ngClass]="{
              'layout-option--selected': layout === LayoutType.CURRENT,
            }"
            (click)="setLayout(LayoutType.CURRENT)"
            [attr.aria-checked]="layout === LayoutType.CURRENT"
            role="radio"
          >
            <div class="layout-icon-container">
              <svg
                width="49"
                height="48"
                viewBox="0 0 49 48"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_6111_5332)">
                  <mask
                    id="mask0_6111_5332"
                    style="mask-type: luminance"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="49"
                    height="48"
                  >
                    <path
                      d="M0.333374 0H48.3324V47.999H0.333374V0Z"
                      fill="white"
                    />
                  </mask>
                  <g mask="url(#mask0_6111_5332)">
                    <path
                      d="M32.208 44.9992H10.2707C7.50515 44.9992 5.12206 44.2651 3.37739 42.8767C1.38617 41.2905 0.333374 38.9383 0.333374 36.0743C0.333374 33.5749 1.27836 31.4056 3.06521 29.8016C4.49394 28.5191 6.4561 27.6256 8.59638 27.2853C8.60201 27.2853 8.60388 27.2853 8.60482 27.2807C9.20856 23.6245 10.8389 20.5223 13.3214 18.3108C15.7364 16.1688 18.8551 14.9902 22.0831 14.9996C24.9171 14.9996 27.5655 15.8799 29.7433 17.5467C31.4451 18.8658 32.8022 20.5773 33.6986 22.5351C33.7956 22.7477 33.941 22.9347 34.1232 23.0813C34.3052 23.2277 34.5192 23.3296 34.7476 23.3788C37.1851 23.9048 39.2851 24.9997 40.8572 26.5663C42.8016 28.5097 43.8328 31.0972 43.8328 34.0493C43.8328 37.129 42.6019 39.9433 40.3641 41.973C38.2182 43.9248 35.3204 44.9992 32.208 44.9992Z"
                      fill="black"
                    />
                    <path
                      d="M32.208 44.9992H10.2707C7.50515 44.9992 5.12206 44.2651 3.37739 42.8767C1.38617 41.2905 0.333374 38.9383 0.333374 36.0743C0.333374 33.5749 1.27836 31.4056 3.06521 29.8016C4.49394 28.5191 6.4561 27.6256 8.59638 27.2853C8.60201 27.2853 8.60388 27.2853 8.60482 27.2807C9.20856 23.6245 10.8389 20.5223 13.3214 18.3108C15.7364 16.1688 18.8551 14.9902 22.0831 14.9996C24.9171 14.9996 27.5655 15.8799 29.7433 17.5467C31.4451 18.8658 32.8022 20.5773 33.6986 22.5351C33.7956 22.7477 33.941 22.9347 34.1232 23.0813C34.3052 23.2277 34.5192 23.3296 34.7476 23.3788C37.1851 23.9048 39.2851 24.9997 40.8572 26.5663C42.8016 28.5097 43.8328 31.0972 43.8328 34.0493C43.8328 37.129 42.6019 39.9433 40.3641 41.973C38.2182 43.9248 35.3204 44.9992 32.208 44.9992Z"
                      fill="#9CA3AF"
                    />
                    <path
                      d="M36.6969 20.7817C37.8312 21.1182 38.9242 21.5807 39.9554 22.1607C40.0052 22.1886 40.0606 22.2049 40.1176 22.2082C40.1745 22.2114 40.2315 22.2016 40.2841 22.1796C40.3366 22.1576 40.3836 22.1238 40.4212 22.0809C40.4588 22.038 40.4861 21.9871 40.501 21.9319C40.727 21.1177 40.8384 20.2759 40.8319 19.4309C40.7953 14.516 36.756 10.5047 31.841 10.5C29.9932 10.4953 28.1892 11.0629 26.6767 12.1246H26.6711C26.6226 12.159 26.5847 12.2064 26.5618 12.2614C26.5389 12.3163 26.532 12.3765 26.5419 12.4353C26.5516 12.4939 26.5778 12.5487 26.6171 12.5932C26.6566 12.6377 26.7078 12.6703 26.7649 12.687C28.502 13.2187 30.13 14.0568 31.572 15.1619C33.3043 16.5008 34.7491 18.1749 35.8204 20.0843C36.0115 20.4213 36.3257 20.6712 36.6969 20.7817Z"
                      fill="black"
                    />
                    <path
                      d="M36.6969 20.7817C37.8312 21.1182 38.9242 21.5807 39.9554 22.1607C40.0052 22.1886 40.0606 22.2049 40.1176 22.2082C40.1745 22.2114 40.2315 22.2016 40.2841 22.1796C40.3366 22.1576 40.3836 22.1238 40.4212 22.0809C40.4588 22.038 40.4861 21.9871 40.501 21.9319C40.727 21.1177 40.8384 20.2759 40.8319 19.4309C40.7953 14.516 36.756 10.5047 31.841 10.5C29.9932 10.4953 28.1892 11.0629 26.6767 12.1246H26.6711C26.6226 12.159 26.5847 12.2064 26.5618 12.2614C26.5389 12.3163 26.532 12.3765 26.5419 12.4353C26.5516 12.4939 26.5778 12.5487 26.6171 12.5932C26.6566 12.6377 26.7078 12.6703 26.7649 12.687C28.502 13.2187 30.13 14.0568 31.572 15.1619C33.3043 16.5008 34.7491 18.1749 35.8204 20.0843C36.0115 20.4213 36.3257 20.6712 36.6969 20.7817Z"
                      fill="#9CA3AF"
                    />
                    <path
                      d="M46.833 20.9993H43.8333C43.4355 20.9993 43.054 20.8412 42.7727 20.56C42.4914 20.2787 42.3334 19.8971 42.3334 19.4994C42.3334 19.1016 42.4914 18.7201 42.7727 18.4388C43.054 18.1576 43.4355 17.9995 43.8333 17.9995H46.833C47.2308 17.9995 47.6123 18.1576 47.8936 18.4388C48.1748 18.7201 48.3329 19.1016 48.3329 19.4994C48.3329 19.8971 48.1748 20.2787 47.8936 20.56C47.6123 20.8412 47.2308 20.9993 46.833 20.9993Z"
                      fill="black"
                    />
                    <path
                      d="M46.833 20.9993H43.8333C43.4355 20.9993 43.054 20.8412 42.7727 20.56C42.4914 20.2787 42.3334 19.8971 42.3334 19.4994C42.3334 19.1016 42.4914 18.7201 42.7727 18.4388C43.054 18.1576 43.4355 17.9995 43.8333 17.9995H46.833C47.2308 17.9995 47.6123 18.1576 47.8936 18.4388C48.1748 18.7201 48.3329 19.1016 48.3329 19.4994C48.3329 19.8971 48.1748 20.2787 47.8936 20.56C47.6123 20.8412 47.2308 20.9993 46.833 20.9993Z"
                      fill="#9CA3AF"
                    />
                    <path
                      d="M31.8333 8.999C31.4355 8.999 31.054 8.84098 30.7727 8.5597C30.4914 8.27842 30.3334 7.89693 30.3334 7.49913V4.49938C30.3334 4.10159 30.4914 3.7201 30.7727 3.43881C31.054 3.15753 31.4355 2.99951 31.8333 2.99951C32.231 2.99951 32.6126 3.15753 32.8939 3.43881C33.1751 3.7201 33.3331 4.10159 33.3331 4.49938V7.49913C33.3331 7.89693 33.1751 8.27842 32.8939 8.5597C32.6126 8.84098 32.231 8.999 31.8333 8.999Z"
                      fill="black"
                    />
                    <path
                      d="M31.8333 8.999C31.4355 8.999 31.054 8.84098 30.7727 8.5597C30.4914 8.27842 30.3334 7.89693 30.3334 7.49913V4.49938C30.3334 4.10159 30.4914 3.7201 30.7727 3.43881C31.054 3.15753 31.4355 2.99951 31.8333 2.99951C32.231 2.99951 32.6126 3.15753 32.8939 3.43881C33.1751 3.7201 33.3331 4.10159 33.3331 4.49938V7.49913C33.3331 7.89693 33.1751 8.27842 32.8939 8.5597C32.6126 8.84098 32.231 8.999 31.8333 8.999Z"
                      fill="#9CA3AF"
                    />
                    <path
                      d="M23.347 12.5139C23.15 12.5143 22.9548 12.4755 22.7729 12.4001C22.5909 12.3246 22.4257 12.2139 22.2867 12.0742L20.1653 9.95379C19.884 9.67247 19.726 9.29095 19.726 8.89311C19.726 8.49528 19.884 8.11373 20.1653 7.83242C20.4467 7.55111 20.8282 7.39307 21.226 7.39307C21.6239 7.39307 22.0054 7.55111 22.2867 7.83242L24.4072 9.95379C24.6168 10.1636 24.7596 10.4308 24.8174 10.7216C24.8751 11.0124 24.8455 11.3139 24.732 11.5879C24.6186 11.8619 24.4264 12.0961 24.1799 12.2609C23.9334 12.4257 23.6436 12.5138 23.347 12.5139Z"
                      fill="black"
                    />
                    <path
                      d="M23.347 12.5139C23.15 12.5143 22.9548 12.4755 22.7729 12.4001C22.5909 12.3246 22.4257 12.2139 22.2867 12.0742L20.1653 9.95379C19.884 9.67247 19.726 9.29095 19.726 8.89311C19.726 8.49528 19.884 8.11373 20.1653 7.83242C20.4467 7.55111 20.8282 7.39307 21.226 7.39307C21.6239 7.39307 22.0054 7.55111 22.2867 7.83242L24.4072 9.95379C24.6168 10.1636 24.7596 10.4308 24.8174 10.7216C24.8751 11.0124 24.8455 11.3139 24.732 11.5879C24.6186 11.8619 24.4264 12.0961 24.1799 12.2609C23.9334 12.4257 23.6436 12.5138 23.347 12.5139Z"
                      fill="#9CA3AF"
                    />
                    <path
                      d="M40.3179 12.5139C40.0214 12.5138 39.7315 12.4257 39.485 12.2609C39.2385 12.0961 39.0463 11.8619 38.9329 11.5879C38.8194 11.3139 38.7897 11.0124 38.8475 10.7216C38.9053 10.4308 39.0481 10.1636 39.2577 9.95379L41.3781 7.83242C41.6594 7.55111 42.041 7.39307 42.4388 7.39307C42.8366 7.39307 43.2182 7.55111 43.4995 7.83242C43.7808 8.11373 43.9389 8.49528 43.9389 8.89311C43.9389 9.29095 43.7808 9.67247 43.4995 9.95379L41.3781 12.0742C41.2392 12.2139 41.0739 12.3246 40.892 12.4001C40.71 12.4755 40.5149 12.5143 40.3179 12.5139Z"
                      fill="black"
                    />
                    <path
                      d="M40.3179 12.5139C40.0214 12.5138 39.7315 12.4257 39.485 12.2609C39.2385 12.0961 39.0463 11.8619 38.9329 11.5879C38.8194 11.3139 38.7897 11.0124 38.8475 10.7216C38.9053 10.4308 39.0481 10.1636 39.2577 9.95379L41.3781 7.83242C41.6594 7.55111 42.041 7.39307 42.4388 7.39307C42.8366 7.39307 43.2182 7.55111 43.4995 7.83242C43.7808 8.11373 43.9389 8.49528 43.9389 8.89311C43.9389 9.29095 43.7808 9.67247 43.4995 9.95379L41.3781 12.0742C41.2392 12.2139 41.0739 12.3246 40.892 12.4001C40.71 12.4755 40.5149 12.5143 40.3179 12.5139Z"
                      fill="#9CA3AF"
                    />
                  </g>
                </g>
                <defs>
                  <clipPath id="clip0_6111_5332">
                    <rect
                      width="48"
                      height="48"
                      fill="white"
                      transform="translate(0.333374)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <div class="layout-label">Current</div>
          </button>
          <button
            type="button"
            class="layout-option"
            [ngClass]="{
              'layout-option--selected': layout === LayoutType.HORIZONTAL,
            }"
            (click)="setLayout(LayoutType.HORIZONTAL)"
            [attr.aria-checked]="layout === LayoutType.HORIZONTAL"
            role="radio"
          >
            <div class="layout-icon-container">
              <ng-container
                *ngTemplateOutlet="
                  weatherIcons;
                  context: { orientation: 'horizontal' }
                "
              ></ng-container>
            </div>
            <div class="layout-label">Horizontal</div>
          </button>
          <button
            type="button"
            class="layout-option"
            [ngClass]="{
              'layout-option--selected': layout === LayoutType.VERTICAL,
            }"
            (click)="setLayout(LayoutType.VERTICAL)"
            [attr.aria-checked]="layout === LayoutType.VERTICAL"
            role="radio"
          >
            <div class="layout-icon-container">
              <ng-container
                *ngTemplateOutlet="
                  weatherIcons;
                  context: { orientation: 'vertical' }
                "
              ></ng-container>
            </div>
            <div class="layout-label">Vertical</div>
          </button>
          <button
            *requireRole="AI_LAYOUT_ROLE"
            type="button"
            class="layout-option"
            [ngClass]="{
              'layout-option--selected': isCustomLayout,
            }"
            (click)="openLayoutAi()"
            [attr.aria-checked]="isCustomLayout"
            role="radio"
          >
            <div class="layout-icon-container">
              <mat-icon svgIcon="ai-gradient" aria-hidden="true"></mat-icon>
            </div>
            <div class="layout-label">AI layout</div>
          </button>
        </div>
        <layout-ai-edit-button
          *requireRole="AI_LAYOUT_ROLE"
          id="te-lw-edit-layout"
          [shown]="isCustomLayout"
          (edit)="editLayoutAi()"
        ></layout-ai-edit-button>
      </div>

      <!-- Days to Show Selection -->
      <div
        class="form-group"
        [shown]="
          isCustomLayout
            ? usesAttribute('daysToShow')
            : [LayoutType.HORIZONTAL, LayoutType.VERTICAL].includes(layout)
        "
      >
        <label
          id="te-lw-days-to-show-label"
          class="control-label"
          for="te-lw-days-to-show"
          >Days to Show:</label
        >
        <mat-form-field
          appearance="outline"
          subscriptSizing="dynamic"
          class="tw-w-full"
        >
          <mat-select
            id="te-lw-days-to-show"
            [(ngModel)]="daysToShow"
            (ngModelChange)="save()"
            aria-labelledby="te-lw-days-to-show-label"
          >
            <mat-option [value]="2">2</mat-option>
            <mat-option [value]="3">3</mat-option>
            <mat-option [value]="4">4</mat-option>
            <mat-option [value]="5">5</mat-option>
            <mat-option [value]="6">6</mat-option>
            <mat-option [value]="7">7</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <!-- Icon Style Selection -->
      <div class="form-group">
        <label class="control-label">Icon Style:</label>
        <mat-button-toggle-group
          [(ngModel)]="iconStyle"
          (ngModelChange)="setIconStyle($event)"
          hideSingleSelectionIndicator="true"
        >
          <mat-button-toggle value="color">Color</mat-button-toggle>
          <mat-button-toggle value="outline">Outline</mat-button-toggle>
        </mat-button-toggle-group>
      </div>

      <!-- Color Picker -->
      <div class="form-group" [shown]="usesAttribute('color')">
        <label for="te-lw-color" class="control-label">Color:</label>
        <div class="flex-row left-right-aligner">
          <color-picker
            pickerId="te-lw-color"
            [(ngModel)]="color"
            (change)="save()"
            ngDefaultControl
          ></color-picker>
        </div>
      </div>

      <!-- Background Color Picker -->
      <div class="form-group" [shown]="usesAttribute('backgroundColor')">
        <label for="te-lw-bg-color" class="control-label">Background:</label>
        <div class="flex-row left-right-aligner">
          <color-picker
            pickerId="te-lw-bg-color"
            [(ngModel)]="backgroundColor"
            (change)="save()"
            ngDefaultControl
          ></color-picker>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Reusable weather icons template with orientation parameter -->
<ng-template #weatherIcons let-orientation="orientation">
  <div [ngClass]="'weather-icons-' + orientation">
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 22H10V18.5H12V22ZM6.40332 17.0107L3.92871 19.4854L2.51465 18.0713L4.98926 15.5967L6.40332 17.0107ZM19.4854 18.0713L18.0713 19.4854L15.5967 17.0107L17.0107 15.5967L19.4854 18.0713ZM11 5C14.3137 5 17 7.68629 17 11C17 14.3137 14.3137 17 11 17C7.68629 17 5 14.3137 5 11C5 7.68629 7.68629 5 11 5ZM3.5 12H0V10H3.5V12ZM22 12H18.5V10H22V12ZM6.40332 4.98926L4.98926 6.40332L2.51465 3.92871L3.92871 2.51465L6.40332 4.98926ZM19.4854 3.92871L17.0107 6.40332L15.5967 4.98926L18.0713 2.51465L19.4854 3.92871ZM12 3.5H10V0H12V3.5Z"
        fill="black"
      />
      <path
        d="M12 22H10V18.5H12V22ZM6.40332 17.0107L3.92871 19.4854L2.51465 18.0713L4.98926 15.5967L6.40332 17.0107ZM19.4854 18.0713L18.0713 19.4854L15.5967 17.0107L17.0107 15.5967L19.4854 18.0713ZM11 5C14.3137 5 17 7.68629 17 11C17 14.3137 14.3137 17 11 17C7.68629 17 5 14.3137 5 11C5 7.68629 7.68629 5 11 5ZM3.5 12H0V10H3.5V12ZM22 12H18.5V10H22V12ZM6.40332 4.98926L4.98926 6.40332L2.51465 3.92871L3.92871 2.51465L6.40332 4.98926ZM19.4854 3.92871L17.0107 6.40332L15.5967 4.98926L18.0713 2.51465L19.4854 3.92871ZM12 3.5H10V0H12V3.5Z"
        fill="#9CA3AF"
      />
    </svg>
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.50004 18.3333C6.13287 18.3333 6.64587 18.8462 6.64587 19.4791C6.64587 20.112 6.13287 20.6249 5.50004 20.6249C4.86721 20.6249 4.35421 20.112 4.35421 19.4791C4.35421 18.8462 4.86721 18.3333 5.50004 18.3333ZM11 18.3333C11.6329 18.3333 12.1459 18.8462 12.1459 19.4791C12.1459 20.112 11.6329 20.6249 11 20.6249C10.3672 20.6249 9.85421 20.112 9.85421 19.4791C9.85421 18.8462 10.3672 18.3333 11 18.3333ZM16.5 18.3333C17.1329 18.3333 17.6459 18.8462 17.6459 19.4791C17.6459 20.112 17.1329 20.6249 16.5 20.6249C15.8672 20.6249 15.3542 20.112 15.3542 19.4791C15.3542 18.8462 15.8672 18.3333 16.5 18.3333ZM8.25004 15.5833C8.88287 15.5833 9.39588 16.0962 9.39588 16.7291C9.39588 17.362 8.88287 17.8749 8.25004 17.8749C7.61721 17.8749 7.10421 17.362 7.10421 16.7291C7.10421 16.0962 7.61721 15.5833 8.25004 15.5833ZM13.75 15.5833C14.3829 15.5833 14.8959 16.0962 14.8959 16.7291C14.8959 17.362 14.3829 17.8749 13.75 17.8749C13.1172 17.8749 12.6042 17.362 12.6042 16.7291C12.6042 16.0962 13.1172 15.5833 13.75 15.5833ZM8.25004 1.83325C10.8107 1.83325 13.0177 3.33335 14.0472 5.49992H14.6667C17.198 5.49992 19.25 7.55195 19.25 10.0833C19.25 12.6145 17.198 14.6666 14.6667 14.6666H8.25004C4.70622 14.6666 1.83337 11.7938 1.83337 8.24992C1.83337 4.70609 4.70622 1.83325 8.25004 1.83325ZM8.25004 3.66659C5.71874 3.66659 3.66671 5.71862 3.66671 8.24992C3.66671 10.7812 5.71874 12.8333 8.25004 12.8333H14.6667C16.1855 12.8333 17.4167 11.6021 17.4167 10.0833C17.4167 8.56447 16.1855 7.33325 14.6667 7.33325H12.7886L12.5729 6.72185C11.9432 4.94054 10.2442 3.66659 8.25004 3.66659Z"
        fill="black"
      />
      <path
        d="M5.50004 18.3333C6.13287 18.3333 6.64587 18.8462 6.64587 19.4791C6.64587 20.112 6.13287 20.6249 5.50004 20.6249C4.86721 20.6249 4.35421 20.112 4.35421 19.4791C4.35421 18.8462 4.86721 18.3333 5.50004 18.3333ZM11 18.3333C11.6329 18.3333 12.1459 18.8462 12.1459 19.4791C12.1459 20.112 11.6329 20.6249 11 20.6249C10.3672 20.6249 9.85421 20.112 9.85421 19.4791C9.85421 18.8462 10.3672 18.3333 11 18.3333ZM16.5 18.3333C17.1329 18.3333 17.6459 18.8462 17.6459 19.4791C17.6459 20.112 17.1329 20.6249 16.5 20.6249C15.8672 20.6249 15.3542 20.112 15.3542 19.4791C15.3542 18.8462 15.8672 18.3333 16.5 18.3333ZM8.25004 15.5833C8.88287 15.5833 9.39588 16.0962 9.39588 16.7291C9.39588 17.362 8.88287 17.8749 8.25004 17.8749C7.61721 17.8749 7.10421 17.362 7.10421 16.7291C7.10421 16.0962 7.61721 15.5833 8.25004 15.5833ZM13.75 15.5833C14.3829 15.5833 14.8959 16.0962 14.8959 16.7291C14.8959 17.362 14.3829 17.8749 13.75 17.8749C13.1172 17.8749 12.6042 17.362 12.6042 16.7291C12.6042 16.0962 13.1172 15.5833 13.75 15.5833ZM8.25004 1.83325C10.8107 1.83325 13.0177 3.33335 14.0472 5.49992H14.6667C17.198 5.49992 19.25 7.55195 19.25 10.0833C19.25 12.6145 17.198 14.6666 14.6667 14.6666H8.25004C4.70622 14.6666 1.83337 11.7938 1.83337 8.24992C1.83337 4.70609 4.70622 1.83325 8.25004 1.83325ZM8.25004 3.66659C5.71874 3.66659 3.66671 5.71862 3.66671 8.24992C3.66671 10.7812 5.71874 12.8333 8.25004 12.8333H14.6667C16.1855 12.8333 17.4167 11.6021 17.4167 10.0833C17.4167 8.56447 16.1855 7.33325 14.6667 7.33325H12.7886L12.5729 6.72185C11.9432 4.94054 10.2442 3.66659 8.25004 3.66659Z"
        fill="#9CA3AF"
      />
    </svg>
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5157 15.927H14.0938L10.4844 21.0833V17.9895H7.90629L11.5157 12.8333V15.927ZM8.25004 1.83325C10.8107 1.83325 13.0177 3.33335 14.0472 5.49992H14.6667C17.198 5.49992 19.25 7.55195 19.25 10.0833C19.25 12.6145 17.198 14.6666 14.6667 14.6666H14.2084V12.8333H14.6667C16.1855 12.8333 17.4167 11.6021 17.4167 10.0833C17.4167 8.56447 16.1855 7.33325 14.6667 7.33325H12.7886L12.5729 6.72184C11.9432 4.94054 10.2442 3.66659 8.25004 3.66659C5.71874 3.66659 3.66671 5.71862 3.66671 8.24992C3.66671 10.6266 5.47563 12.58 7.79171 12.81V14.6487C4.46185 14.4136 1.83337 11.6396 1.83337 8.24992C1.83337 4.70609 4.70622 1.83325 8.25004 1.83325Z"
        fill="black"
      />
      <path
        d="M11.5157 15.927H14.0938L10.4844 21.0833V17.9895H7.90629L11.5157 12.8333V15.927ZM8.25004 1.83325C10.8107 1.83325 13.0177 3.33335 14.0472 5.49992H14.6667C17.198 5.49992 19.25 7.55195 19.25 10.0833C19.25 12.6145 17.198 14.6666 14.6667 14.6666H14.2084V12.8333H14.6667C16.1855 12.8333 17.4167 11.6021 17.4167 10.0833C17.4167 8.56447 16.1855 7.33325 14.6667 7.33325H12.7886L12.5729 6.72184C11.9432 4.94054 10.2442 3.66659 8.25004 3.66659C5.71874 3.66659 3.66671 5.71862 3.66671 8.24992C3.66671 10.6266 5.47563 12.58 7.79171 12.81V14.6487C4.46185 14.4136 1.83337 11.6396 1.83337 8.24992C1.83337 4.70609 4.70622 1.83325 8.25004 1.83325Z"
        fill="#9CA3AF"
      />
    </svg>
  </div>
</ng-template>
